module.exports = __webpack_public_path__ + "static/diema1-8909488fc97576055a32ccd565e34149.png";